module.exports = __webpack_public_path__ + "static/media/toshiba-menu-schedule_nexus.8247b249.jpg";